import * as React from 'react';

import { IButtonStyles } from '@fluentui/react';

import { AppButton, AppPersonaButton } from '@ms/acui-button';

import { CollabControlProps } from './CollabControlProps';

/**
 * Function that will convert control props into controls that can be rendered within the action hub.
 * @param props the control props that will be converted to a JSX element
 */
export const getActionHubControlRenderer = (styles?: IButtonStyles) => {
  return (props: CollabControlProps) => {
    switch (props.type) {
      case 'AppButtonProps':
        return <AppButton styles={styles} role={'menuitem'} {...props} />;
      case 'AppPersonaButtonProps':
        return <AppPersonaButton styles={styles} role={'menuitem'} {...props} />;
    }
  };
};
